import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private readonly http: HttpClient,
  ) { }

  /**
   * Service to get client data from her id
   * @param idClient id of client
   * @returns client data
   */
  public getClient(idClient: string): Observable<any> {
    //return this.http.get<any>(`/get/client`);
    return this.http.get<any>(`/client/${idClient}`);
  }

  /**
   * Get the data validations of the enrollment
   * @param idClient id of client
   * @param idCompany id of company for client
   * @param idTransaction id of transaction for company about the enrollment
   * @returns data validations
   */
  public getClientValidation(idClient: string, idCompany: string, idTransaction: string): Observable<any> {
    return this.http.get<any>(`/client/validation/${idClient}?companyId=${idCompany}&transactionId=${idTransaction}`);
  }

  /**
   * Only call the service for execute bio start ONLY when status of client is successfull (1)
   * @param idClient Id of the client
   * @returns anything
   */
  public callBioStart(idClient: string): Observable<any> {
    return this.http.get<any>(`/client/biostar?id=${idClient}`);
  }

  /**
   * Delete a client form her id
   * @param idClient id of client
   * @returns result about operation that deleted client
   */
  public deleteClient(idClient: string): Observable<any> {
    return this.http.delete(`/client/${idClient}`);
  }

  /**
   * Confirmation client: 
   * 1. Admin can accept manual success any client's enrollment and execute bio start and nom151
   * 2. After execute any re validation send to execute bio start and nom151
   * @param idClient id of the client
   * @param type type the request, if is manual or by re executed validations
   * @param description (optional) only description of the manual acception
   * @param userId id of user active (admin)
   * @returns get the response of the request
   */
  public confirmationClient(idClient: string, type: string, description: string, userId: string): Observable<any> {
    const build = {
      type: type,
      description: description,
      userId: userId,
    }
    const body = JSON.stringify(build);
    return this.http.put<any>(`/client/confirmation/${idClient}`, body);
  }

}
